// src/services/permissionService.js

import api from '../fapis/client';
import endpoints from '../fapis/endpoints';

const formatErrorMessage = (error) => {
  if (error.message === 'Failed to fetch' || error.code === 'ERR_NETWORK') {
    return 'Unable to connect to the server. Please check your internet connection and try again.';
  }
  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    return 'The request timed out. Please try again.';
  }
  if (error.response) {
    const status = error.response.status;
    if (status === 403) {
      return 'You do not have permission to view permissions.';
    }
    if (status === 401) {
      return 'Your session has expired. Please login again.';
    }
    return error.response.data?.detail || error.response.data?.message || error.message;
  }
  return error.message || 'An unexpected error occurred. Please try again.';
};

export const permissionService = {
  getPermissionsGrouped: async () => {
    try {
      const response = await api.get(endpoints.retailone.permissions.grouped);
      return {
        success: true,
        data: response.data || [],
        status: response.status
      };
    } catch (error) {
      console.error('❌ Get permissions grouped error:', error);
      return {
        success: false,
        message: formatErrorMessage(error),
        status: error.response?.status || error.status || 500,
        data: []
      };
    }
  },

  getPermissions: async () => {
    try {
      const response = await api.get(endpoints.retailone.permissions.list);
      return {
        success: true,
        data: response.data || [],
        status: response.status
      };
    } catch (error) {
      console.error('❌ Get permissions error:', error);
      return {
        success: false,
        message: formatErrorMessage(error),
        status: error.response?.status || error.status || 500,
        data: []
      };
    }
  },

  getPermissionsByFeature: async (featureUuid) => {
    if (!featureUuid) {
      return {
        success: false,
        message: 'Feature ID is required',
        status: 400
      };
    }

    try {
      const response = await api.get(endpoints.retailone.permissions.grouped);
      const groupedData = response.data || [];
      const feature = groupedData.find(f => f.feature?.uuid === featureUuid);
      
      return {
        success: true,
        data: feature || null,
        status: response.status
      };
    } catch (error) {
      console.error(`❌ Get permissions for feature ${featureUuid} error:`, error);
      return {
        success: false,
        message: formatErrorMessage(error),
        status: error.response?.status || error.status || 500,
        data: null
      };
    }
  },

  getLicensedFeatures: async () => {
    try {
      const response = await api.get(endpoints.retailone.permissions.grouped);
      const groupedData = response.data || [];
      const licensedFeatures = groupedData
        .filter(f => f.is_licensed === true)
        .map(f => f.feature);
      
      return {
        success: true,
        data: licensedFeatures || [],
        status: response.status
      };
    } catch (error) {
      console.error('❌ Get licensed features error:', error);
      return {
        success: false,
        message: formatErrorMessage(error),
        status: error.response?.status || error.status || 500,
        data: []
      };
    }
  }
};

export default permissionService;